import "@fancyapps/fancybox";
import "@fortawesome/fontawesome-free/js/all.js";
import "./foundation.js";
import "./fontLoad.js";
import "./carousels.js";
import "./handleInputNumber.js";
import "./stickyFooter.js";
import "./handleFiles.js";
import "./stepper.min.js";
import "./jquery.inputmask.min.js";
// import "./litePicker.js";
import "../scss/style.scss";

(function($) {
    "use strict";
    $(function() {
        // your code here

        // Lightpicker - date picker for date input
        // https://wakirin.github.io/Litepicker/#anchor-Usage
        $("[data-datepicker]").each(function() {
            new Litepicker({ element: this, lang: "ru-RU", format: "D MMM, YYYY", singleMode: true });
        });
        $("[data-datemultipicker]").each(function() {
            new Litepicker({
                element: this,
                lang: "ru-RU",
                format: "D MMM, YYYY",
                singleMode: true,
                numberOfMonths: 2,
                numberOfColumns: 2,
                autoApply: false,
            });
        });
        $("[data-daterangepicker]").each(function() {
            new Litepicker({
                element: this,
                lang: "ru-RU",
                format: "D MMM, YYYY",
                singleMode: false,
                numberOfMonths: 2,
                numberOfColumns: 2,

            });
        });



        // Time input mask
        // https://github.com/RobinHerbots/Inputmask
        $("[data-timepicker]").inputmask({
            alias: "datetime",
            placeholder: "ЧЧ:ММ",
            inputFormat: "HH:MM",
            insertMode: false,
            showMaskOnHover: false,
            hourFormat: "24",
        });


        // $('[data-timepicker]').each(function(){
        //   $(this).inputmask("HH:MM", {
        //     placeholder: "ЧЧ:ММ",
        //     insertMode: false,
        //     showMaskOnHover: false,
        //     hourFormat: "24"
        //   });
        // });

        $(".menu")
            .find(".header-link")
            .on("click", function(e) {
                e.preventDefault();
            });
    });
})(jQuery);
//